export enum AnchorsEnum {
    THREE_STEPS = "three_steps",
    FAQ = "faq",
    LIFEHACKS = "life_hacks",
}
